(() => {
  'use strict';
  // Section-local enhancement. Purchases and the existing drawer stay in theme.js.
  if (window.OudProductPage) { window.OudProductPage.init(document); return; }
  const all = (selector, scope = document) => [...scope.querySelectorAll(selector)];
  const one = (selector, scope = document) => scope.querySelector(selector);
  const announce = text => { const el = one('#GlobalStatus'); if (el) el.textContent = text; };
  function stopMedia(panel) {
    all('video', panel).forEach(video => video.pause());
    all('iframe', panel).forEach(frame => {
      if (!frame.contentWindow) return;
      try {
        const origin = new URL(frame.src, location.href).origin;
        frame.contentWindow.postMessage(JSON.stringify({event:'command',func:'pauseVideo',args:[]}), origin);
        frame.contentWindow.postMessage(JSON.stringify({method:'pause'}), origin);
      } catch (_) { /* A media provider may not expose playback control. */ }
    });
    all('model-viewer', panel).forEach(model => model.pause?.());
  }
  function initGallery(gallery) {
    if (gallery.dataset.galleryInitialized) return;
    gallery.dataset.galleryInitialized = 'true';
    const media = all('[data-gallery-media]', gallery);
    const thumbs = all('[data-gallery-select]', gallery);
    if (!media.length) return;
    let index = Math.max(0, media.findIndex(panel => !panel.hidden));
    const show = (next, notify = true) => {
      index = (next + media.length) % media.length;
      media.forEach((panel, i) => { panel.hidden = i !== index; if (i !== index) stopMedia(panel); });
      thumbs.forEach(thumb => {
        const active = thumb.dataset.gallerySelect === media[index].dataset.mediaId;
        if (active) thumb.setAttribute('aria-current', 'true'); else thumb.removeAttribute('aria-current');
      });
      const counter = one('[data-gallery-counter]', gallery);
      if (counter) counter.textContent = `${index + 1} / ${media.length}`;
      if (notify) announce(`Product media ${index + 1} of ${media.length}.`);
    };
    gallery.addEventListener('click', event => {
      const thumb = event.target.closest('[data-gallery-select]');
      if (thumb) { event.preventDefault(); const next = media.findIndex(panel => panel.dataset.mediaId === thumb.dataset.gallerySelect); if (next >= 0) show(next); }
      if (event.target.closest('[data-gallery-prev]')) show(index - 1);
      if (event.target.closest('[data-gallery-next]')) show(index + 1);
      const zoom = event.target.closest('[data-gallery-zoom]');
      if (zoom) {
        const dialog = one('[data-gallery-dialog]', gallery.closest('[data-product-section]'));
        const img = dialog && one('[data-zoom-image]', dialog);
        if (!dialog?.showModal || !img) return;
        img.src = zoom.dataset.galleryZoom; img.alt = zoom.dataset.alt || '';
        dialog.showModal(); document.body.classList.add('dialog-open');
        const onClose = () => { document.body.classList.toggle('dialog-open', !!one('dialog[open]')); if (zoom.isConnected) zoom.focus({preventScroll:true}); };
        dialog.addEventListener('close', onClose, {once:true});
        one('[data-close]', dialog)?.focus();
      }
    });
    gallery.addEventListener('keydown', event => {
      if (!event.target.closest('[data-gallery-select],[data-gallery-prev],[data-gallery-next]')) return;
      let next;
      if (event.key === 'ArrowLeft') next = index - 1;
      if (event.key === 'ArrowRight') next = index + 1;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = media.length - 1;
      if (next === undefined) return;
      event.preventDefault(); show(next);
      thumbs.find(thumb => thumb.getAttribute('aria-current') === 'true')?.focus({preventScroll:true});
    });
    let touch;
    gallery.addEventListener('touchstart', event => {
      if (event.target.closest('video,iframe,model-viewer,input,a') || (event.target.closest('button') && !event.target.closest('[data-gallery-zoom]'))) return;
      const point = event.touches[0]; touch = point && {x:point.clientX,y:point.clientY};
    }, {passive:true});
    gallery.addEventListener('touchend', event => {
      const point = event.changedTouches[0];
      if (touch && point) { const dx=point.clientX-touch.x,dy=point.clientY-touch.y; if(Math.abs(dx)>50 && Math.abs(dx)>Math.abs(dy)*1.4) { if(event.cancelable)event.preventDefault();show(index+(dx<0?1:-1)); } }
      touch = null;
    }, {passive:false});
    gallery.addEventListener('touchcancel', () => { touch=null; }, {passive:true});
    show(index, false);
  }
  function quantityControls(section) {
    const input = one('input[name="quantity"]', section);
    if (!input || input.type === 'hidden') return;
    const current = Number(input.value), min=Number(input.min)||1, step=Number(input.step)||1;
    const max=input.hasAttribute('max')?Number(input.max):Infinity;
    all('[data-quantity-step]', section).forEach(button => { button.disabled = input.disabled || (Number(button.dataset.quantityStep)<0?current<=min:current+step>max); });
  }
  function updatePlan(section, select) {
    const option=select.selectedOptions[0]; if(!option)return;
    const current=one('[data-product-price-current]',section),compare=one('[data-product-price-compare]',section),sale=one('[data-product-sale]',section),sticky=one('[data-sticky-price]',section);
    if(current)current.textContent=option.dataset.price;
    if(compare){compare.textContent=option.dataset.comparePrice;compare.hidden=option.dataset.onSale!=='true';}
    if(sale)sale.hidden=option.dataset.onSale!=='true';
    if(sticky)sticky.textContent=option.dataset.price;
    announce('Purchase option updated.');
  }
  const rulesRequests=new WeakMap();
  async function refreshPurchaseRules(section) {
    if(!section.isConnected || !section.dataset.productUrl || section.hasAttribute('aria-busy'))return;
    const form=one('[data-product-form]',section),variant=one('input[name="id"]',form||section)?.value;
    if(!form || !variant)return;
    rulesRequests.get(section)?.abort();const request=new AbortController();rulesRequests.set(section,request);
    const url=new URL(section.dataset.productUrl,location.origin);url.searchParams.set('variant',variant);url.searchParams.set('section_id',section.dataset.sectionId);
    const sellingPlan=one('[data-selling-plan]',section)?.value;if(sellingPlan)url.searchParams.set('selling_plan',sellingPlan);
    try{
      const response=await fetch(url,{signal:request.signal});if(!response.ok)return;
      const next=new DOMParser().parseFromString(await response.text(),'text/html').querySelector('[data-product-section]');
      if(!next || !section.isConnected || request.signal.aborted || one('input[name="id"]',form)?.value!==variant)return;
      const nextForm=one('[data-product-form]',next),input=one('input[name="quantity"]',section),newInput=one('input[name="quantity"]',next);
      if(!nextForm)return;
      form.dataset.canPurchase=nextForm.dataset.canPurchase;form.dataset.variantAvailable=nextForm.dataset.variantAvailable;
      section.dataset.canPurchase=next.dataset.canPurchase;
      if(input&&newInput){
        for(const attr of ['min','max','step','disabled','data-cart-qty','data-quantity-min','data-quantity-max','data-quantity-increment','data-quantity-rule-min','data-quantity-rule-max','data-quantity-rule-increment']){if(newInput.hasAttribute(attr))input.setAttribute(attr,newInput.getAttribute(attr));else input.removeAttribute(attr);}
        const min=Number(input.min||input.dataset.quantityMin)||1,step=Number(input.step||input.dataset.quantityIncrement)||1,max=input.hasAttribute('max')?Number(input.max):Infinity;
        const limit=Number.isFinite(max)?min+Math.floor((max-min)/step)*step:Infinity;
        input.value=Math.max(min,Math.min(limit,min+Math.round((Number(input.value)-min)/step)*step));
      }
      const id=one('input[name="id"]',form);if(id)id.disabled=nextForm.dataset.canPurchase==='false';
      for(const selector of ['.add-button','[data-sticky-add]']){
        const button=one(selector,section),replacement=one(selector,next);if(!button||!replacement)continue;
        button.disabled=replacement.disabled||!!form.dataset.busy;
        if(!form.dataset.busy)button.textContent=replacement.textContent;
      }
      const payment=one('.shopify-payment-button',form);if(payment){payment.hidden=nextForm.dataset.canPurchase==='false';payment.inert=payment.hidden;}
      const checkout=one('[data-product-checkout]',form);if(checkout){checkout.hidden=nextForm.dataset.canPurchase==='false';checkout.inert=checkout.hidden;}
      const notice=one('[data-product-quantity-notice]',form),newNotice=one('[data-product-quantity-notice]',nextForm);
      if(notice&&newNotice)notice.replaceWith(newNotice);else if(notice)notice.remove();else if(newNotice)one('[data-form-error]',form)?.before(newNotice);
      for(const selector of ['[data-product-availability]','.oa-quantity-rules']){const old=one(selector,section),replacement=one(selector,next);if(old&&replacement)old.innerHTML=replacement.innerHTML;}
      const label=input?.id && one(`label[for="${CSS.escape(input.id)}"]`,section),newLabel=newInput?.id && one(`label[for="${CSS.escape(newInput.id)}"]`,next);if(label&&newLabel)label.innerHTML=newLabel.innerHTML;
      quantityControls(section);
    }catch(error){if(error.name!=='AbortError'){/* Shopify still enforces inventory if this optional refresh fails. */}}
  }
  function init(scope = document) {
    all('[data-product-gallery]', scope).forEach(initGallery);
    if (scope.matches?.('[data-product-gallery]')) initGallery(scope);
    const sections=all('[data-product-section]',scope);
    if(scope.matches?.('[data-product-section]'))sections.push(scope);
    sections.forEach(section => {
      quantityControls(section);
      if (section.dataset.productInitialized) return;
      section.dataset.productInitialized='true';
      section.addEventListener('oud:quantity-updated', () => quantityControls(section));
      section.addEventListener('change', event => {
        if(event.target.matches('input[name="quantity"]'))quantityControls(section);
        if(event.target.matches('[data-selling-plan]'))updatePlan(section,event.target);
      });
    });
  }
  window.OudProductPage = {init};
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('oud:product-updated', () => init(document));
  document.addEventListener('oud:cart-updated', () => all('[data-product-section]').forEach(refreshPurchaseRules));
  init(document);
})();
